export { default } from './DialogContentText';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/DialogContentText/index.js
// module id = 450
// module chunks = 121